const Publish = () => (
  <div>
    <h1>Publish</h1>
  </div>
);

export default Publish;
